import React, { useEffect } from 'react';
import { Afp } from '../../../../app/models/Afp';
import useHandleErrorFields from '../../../../hooks/useHandleErrorFields';
import { Currency } from '../../../../app/models/Currency';

type Props = {
    currencyDataForm: Currency;
    setCurrencyDataForm: (currency: Currency) => void;
    errorFields?: any;
};

const CurrencyForm = ({ currencyDataForm, setCurrencyDataForm, errorFields }: Props) => {
    const { fieldErrorMessage, fieldHasError, onFocusRemove, setErrors } = useHandleErrorFields();

    useEffect(() => {
        setErrors(errorFields);
    }, [errorFields]);

    const handleChange = (
        e: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLSelectElement>
    ) => {
        const { name, value } = e.target;
        // Convertir código ISO a mayúsculas automáticamente
        const processedValue = name === 'iso_code' ? value.toUpperCase() : value;
        setCurrencyDataForm({ ...currencyDataForm, [name]: processedValue });
    };

    return (
        <>
            <div className="mb-2 row needs-validation">
                <label className="col-md-3 col-form-label">Nombre</label>
                <div className="col-md-9">
                    <input
                        name="name"
                        id="name"
                        type="text"
                        className={`form-control ${fieldHasError('name')}`}
                        value={currencyDataForm.name}
                        onChange={handleChange}
                        onFocus={() => onFocusRemove('name')}
                        placeholder="Ingrese el nombre de moneda"
                    />
                    <div className="invalid-feedback" style={{ display: 'flex' }}>
                        {fieldErrorMessage('name')}
                    </div>
                </div>
            </div>
            <div className="mb-2 row needs-validation">
                <label className="col-md-3 col-form-label">Código ISO <span className="text-danger">*</span></label>
                <div className="col-md-9">
                    <input
                        name="iso_code"
                        id="iso_code"
                        type="text"
                        className={`form-control ${fieldHasError('iso_code')}`}
                        value={currencyDataForm.iso_code || ''}
                        onChange={handleChange}
                        onFocus={() => onFocusRemove('iso_code')}
                        placeholder="Ej: USD, EUR, CLP"
                        maxLength={3}
                        required
                        style={{ textTransform: 'uppercase' }}
                    />
                    <div className="invalid-feedback" style={{ display: 'flex' }}>
                        {fieldErrorMessage('iso_code')}
                    </div>
                    <small className="form-text text-muted">
                        Código ISO 4217 (máximo 3 caracteres)
                    </small>
                </div>
            </div>
        </>
    );
};

export default CurrencyForm;
